// extracted by mini-css-extract-plugin
export default {"loading":"LoadingDots_loading__7hm0q","blink":"LoadingDots_blink__EPMbc","lg":"LoadingDots_lg__Rz+0X","xl":"LoadingDots_xl__cwyC9"};